var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "profile"
  }, [_c('advertisement-top-banner-text'), _c('div', {
    staticClass: "container"
  }, [_c('b-row', [_c('b-col', {
    staticClass: "py-0",
    attrs: {
      "md": "5"
    }
  }, [_vm.$options.components['profile-my-account-detail'] ? [_c('profile-my-account-detail')] : _vm._e()], 2), _vm.isLoggedin ? _c('b-col', {
    attrs: {
      "md": "7"
    }
  }, [_vm.$options.components['profile-show-edit-profile'] ? [_c('profile-show-edit-profile')] : _vm._e()], 2) : _vm._e()], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }